import { Pipe, PipeTransform } from '@angular/core';
import { ActivityNote } from '@wdx/clmi/clmi-swagger-gen';
import { NOTE_FORM_ID } from '@wdx/shared/utils';
import { DateTime } from 'luxon';
import { NoteData } from '../models/note-data.model';

@Pipe({ name: 'notesToNoteData', standalone: false })
export class NotesToNoteDataPipe implements PipeTransform {
    transform(notes: ActivityNote[]): NoteData[] {
        return notes
            ? notes.map<NoteData>((note) => ({
                  dueDate: note.due,
                  formSetup: {
                      formId: NOTE_FORM_ID,
                      entityId: note.id,
                  },
                  isImportant:
                      (note.importantUntil &&
                          DateTime.fromISO(note.importantUntil) >
                              DateTime.local()) ||
                      false,
                  value: note.content,
              }))
            : [];
    }
}
